"use client";

import { useEffect } from "react";

import { capturePosthogEvent } from "@/lib/posthog-browser";
import { useAuth } from "@/providers/auth";

export function HomePageAnalytics() {
	const { user, isSessionResolving } = useAuth();

	useEffect(() => {
		if (isSessionResolving) return;
		void capturePosthogEvent("page_viewed", {
			page_name: "home",
			is_logged_in: !!user,
			user_plan: user?.membership?.planId ?? "free",
		});
	}, [isSessionResolving, user]);

	return null;
}
